import { Link } from "react-router-dom";
import { SITE } from "../config";
import { usePageMeta } from "../seo";
import LegalLayout from "../components/LegalLayout";

const UPDATED = "Effective 20 October 2026";

export default function Terms() {
  usePageMeta("/terms");
  const mail = <a href={`mailto:${SITE.contactEmail}`}>{SITE.contactEmail}</a>;
  return (
    <LegalLayout title="Terms of use" updated={UPDATED}>
      <section>
        <p>
          These terms cover your use of {SITE.productName}, a helpdesk operated
          by {SITE.productName}, Bangalore, India ("we").{" "}
          By signing in, you agree to them on behalf of yourself and the
          organization you use {SITE.productName} for.
        </p>
      </section>

      <section>
        <h2>The beta</h2>
        <p>
          {SITE.productName} is in beta and free to use while it is. Features
          may change, be added or be removed, and there may be bugs and
          downtime. We'll announce pricing before the beta ends and give
          organizations notice before any charges apply.
        </p>
      </section>

      <section>
        <h2>Your account</h2>
        <p>
          You sign in with a Google account. Keep it secure; whatever is done
          with your session counts as done by you. Your organization's owners
          and admins decide who has access and with which role.
        </p>
      </section>

      <section>
        <h2>Your data</h2>
        <p>
          Your organization keeps all rights to the data it brings into{" "}
          {SITE.productName}, including its customers' messages. We use it only
          to provide the service, as described in the{" "}
          <Link to="/privacy">privacy policy</Link>. You're responsible for
          having the right to bring that data in and to contact your customers
          through the channels you connect.
        </p>
      </section>

      <section>
        <h2>Services you connect</h2>
        <p>
          When you connect a mailbox, WhatsApp number, Acefone account, store,
          or an OpenAI or Anthropic key, your use of that service is governed by
          your agreement with its provider, and its charges are yours. For
          example, WhatsApp messages must follow Meta's WhatsApp Business
          policies.
        </p>
      </section>

      <section>
        <h2>AI features</h2>
        <p>
          AI drafts and summaries are produced by the provider you choose and
          can be wrong. They're suggestions: an agent should read and edit a
          draft before sending it, and you're responsible for what your team
          sends.
        </p>
      </section>

      <section>
        <h2>Acceptable use</h2>
        <ul>
          <li>Don't use {SITE.productName} to send spam or unlawful content.</li>
          <li>Don't try to access another organization's data, or to break or overload the service.</li>
          <li>Don't use it in a way that breaks the law or the terms of the services you connect.</li>
        </ul>
        <p>We may suspend access that breaks these rules.</p>
      </section>

      <section>
        <h2>No warranty, limited liability</h2>
        <p>
          During the beta, {SITE.productName} is provided as it is, without
          promises of availability or fitness for a particular purpose, to the
          extent the law allows. To that extent, we aren't liable for indirect
          or consequential losses, such as lost profits or lost data, and our
          total liability for anything arising from {SITE.productName} is
          limited to the amount you paid us for it in the twelve months before
          the claim, which during the free beta is nothing.
        </p>
      </section>

      <section>
        <h2>Ending use</h2>
        <p>
          You can stop using {SITE.productName} at any time and ask us to
          delete your organization's data by emailing {mail}. We may end the
          beta or your access with reasonable notice, except where we suspend
          access for misuse.
        </p>
      </section>

      <section>
        <h2>Changes</h2>
        <p>
          We may update these terms as the product changes. We'll update this
          page and the date at the top, and tell organizations about
          significant changes.
        </p>
      </section>

      <section>
        <h2>Governing law</h2>
        <p>
          These terms are governed by the laws of India, and the courts in
          Bangalore have jurisdiction over any dispute about them.
        </p>
      </section>

      <section>
        <h2>Contact</h2>
        <p>Questions about these terms: {mail}.</p>
      </section>
    </LegalLayout>
  );
}
